import ModelLookup from "@auer-steel/CustomTypes/ModelLookup";
import ModelPartsLookup from "@auer-steel/CustomTypes/ModelPartsLookup";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import React, { useState } from "react";

interface ViewNames {
    modelSearchResultsList: string;
    modelSearchListDetail: string;
}

interface ModelLookupProduct {
    criticalPart: string;
    drawingExists: string;
    drawingLink: string;
    groups: string;
    modelFamily: string;
    partDescription: string;
    partHistory: string;
    partNumber: string;
    partQuantity: number;
    replacedPartNumber: string;
    salesPackageNumber: string;
    sequenceNumber: string;
    sigChartLink: string;
    showSpinner: boolean;
}

const ModelLookupContext = React.createContext({
    currentModelLookupProduct: [] as ModelLookupProduct[],
    currentSelectedGroup: "", 
    currentSelectedProduct: {} as ProductDto,
    displayDetailsView: false,
    isLoading: false,
    modelLookupResultsData: {},
    modelLookupRootUri: "",
    modelNumber: "",
    modelPartsLookupResultsData: [] as ModelPartsLookup[],
    handleSetCurrentModelLookupProduct: (data: ModelLookupProduct[]) => {},
    handleSetCurrentSelectedGroup: (group: string) => {},
    handleSetCurrentSelectedProduct: (data: ProductDto) => {},
    handleSetDisplayDetailsView: (data: boolean) => {},
    handleSetIsLoading: (isLoading: boolean) => {},
    handleSetModelLookupResultsData: (data: ModelLookup) => {},
    handleSetModelLookupRootUri: (rootUri: string) => {},
    handleSetModelNumber: (modelNumber: string) => {},
    handleSetModelPartsLookupResultsData: (data: ModelPartsLookup[]) => {},
});

export { ModelLookupContext, ViewNames, ModelLookupProduct };
